import "./weather-accessory";

import { Storybook } from "@tento-ui/ui/storybook";
import { WeatherAccessory } from "./weather-accessory";
import { NaiveDate } from "@tento-chrono";
import { WeatherLocations } from "@tento-lona";

export class WeatherAccessoryStoryBook extends Storybook.Default {
  title(): string {
    return "Weather Accessory";
  }

  examples(): Storybook.Example[] {
    const today = NaiveDate.today();

    return [
      {
        title: "San Francisco (fallback table)",
        render: () => {
          return WeatherAccessory.makeWith({
            lid: WeatherLocations.FALLBACK.all[0].id,
            date: today,
          });
        },
      },
      {
        title: "Palo Alto",
        render: () => {
          return WeatherAccessory.makeWith({
            lid: WeatherLocations.FALLBACK.all[1].id,
            date: today,
          });
        },
      },
      {
        title: "New York",
        render: () => {
          return WeatherAccessory.makeWith({
            lid: WeatherLocations.FALLBACK.all[3].id,
            date: today,
          });
        },
      },
    ];
  }
}
